export default (): boolean =>
  typeof window !== "undefined" && typeof window.document === "object";
